import * as actionTypes from '../actions';
import {addItemInListOfItems, deleteItemByIdInListOfItems, deleteItemByListOfIdsInListOfItems, getEmptyCustomer, updateItemInListOfItems} from "../../helpers";
import queryClient from '@/queries/queryClient';
import { CUSTOMERS_KEY } from '@/queries/customers/hooks';


const initialState = {
    customers: [],
    currentCustomer: getEmptyCustomer(),

    getCustomersLoading: false,
    getCustomersError: null,

    getCustomerReservationsLoading: false,
    getCustomerReservationsError: null,

    getCustomerDuplicatesLoading: false,
    getCustomerDuplicatesError: null,

    addCustomerLoading: false,
    addCustomerError: null,

    deleteCustomerLoading: false,
    deleteCustomerError: null,

    updateCustomerLoading: false,
    updateCustomerError: null,

    fuseCustomersLoading: false,
    fuseCustomersError: null,
};

const customersReducer = (state = initialState, action) => {

    queryClient.invalidateQueries({
        queryKey: [CUSTOMERS_KEY],
    });

    switch (action.type) {

        // GET CUSTOMERS
        case actionTypes.GET_CUSTOMERS_REQUEST:
            return {
                ...state,
                getCustomersLoading: action.loading
            };
        case actionTypes.GET_CUSTOMERS_SUCCESS:
            return {
                ...state,
                getCustomersLoading: action.loading,
                getCustomersError: action.error,
                customers: action.customers
            };
        case actionTypes.GET_CUSTOMERS_ERROR:
            return {
                ...state,
                getCustomersLoading: action.loading,
                getCustomersError: action.error
            };

        // GET CUSTOMER RESERVATIONS
        case actionTypes.GET_CUSTOMER_RESERVATIONS_REQUEST:
            return {
                ...state,
                getCustomerReservationsLoading: action.loading
            };
        case actionTypes.GET_CUSTOMER_RESERVATIONS_SUCCESS:
            return {
                ...state,
                getCustomerReservationsLoading: action.loading,
                getCustomerReservationsError: action.error,
            };
        case actionTypes.GET_CUSTOMER_RESERVATIONS_ERROR:
            return {
                ...state,
                getCustomerReservationsLoading: action.loading,
                getCustomerReservationsError: action.error
            };

        // GET CUSTOMER DULICATES
        case actionTypes.GET_CUSTOMER_DUPLICATES_REQUEST:
            return {
                ...state,
                getCustomerDuplicatesLoading: action.loading
            };
        case actionTypes.GET_CUSTOMER_DUPLICATES_ERROR:
        case actionTypes.GET_CUSTOMER_DUPLICATES_SUCCESS:
            return {
                ...state,
                getCustomerDuplicatesLoading: action.loading,
                getCustomerDuplicatesError: action.error,
            };

        // ADD CUSTOMER
        case actionTypes.ADD_CUSTOMER_REQUEST:
            return {
                ...state,
                addCustomerLoading: action.loading
            };
        case actionTypes.ADD_CUSTOMER_SUCCESS:
            return {
                ...state,
                addCustomerLoading: action.loading,
                addCustomerError: action.error,
                customers: addItemInListOfItems(state.customers, action.customer)
            };
        case actionTypes.ADD_CUSTOMER_ERROR:
            return {
                ...state,
                addCustomerLoading: action.loading,
                addCustomerError: action.error
            };

        // DELETE CUSTOMER
        case actionTypes.DELETE_CUSTOMER_REQUEST:
            return {
                ...state,
                deleteCustomerLoading: action.loading
            };
        case actionTypes.DELETE_CUSTOMER_SUCCESS:
            return {
                ...state,
                deleteCustomerLoading: action.loading,
                deleteCustomerError: action.error,
                customers: deleteItemByIdInListOfItems(state.customers, action.customerId)
            };
        case actionTypes.DELETE_CUSTOMER_ERROR:
            return {
                ...state,
                deleteCustomerLoading: action.loading,
                deleteCustomerError: action.error
            };
        
        // BULK DELETE CUSTOMER
        case actionTypes.BULK_DELETE_CUSTOMER_REQUEST:
            return {
                ...state,
                deleteCustomerLoading: action.loading
            };
        case actionTypes.BULK_DELETE_CUSTOMER_SUCCESS:
            return {
                ...state,
                deleteCustomerLoading: action.loading,
                deleteCustomerError: action.error,
                customers: deleteItemByListOfIdsInListOfItems(state.customers, action.customerIds),
            };
        case actionTypes.BULK_DELETE_CUSTOMER_ERROR:
            return {
                ...state,
                deleteCustomerLoading: action.loading,
                deleteCustomerError: action.error
            };

        // UPDATE CUSTOMER
        case actionTypes.UPDATE_CUSTOMER_REQUEST:
            return {
                ...state,
                updateCustomerLoading: action.loading
            };
        case actionTypes.UPDATE_CUSTOMER_SUCCESS:
            return {
                ...state,
                updateCustomerLoading: action.loading,
                updateCustomerError: action.error,
                customers: updateItemInListOfItems(state.customers, action.customer)
            };
        case actionTypes.UPDATE_CUSTOMER_ERROR:
            return {
                ...state,
                updateCustomerLoading: action.loading,
                updateCustomerError: action.error
            };
        
        // SET CURRENT CUSTOMER
        case actionTypes.SET_CURRENT_CUSTOMER:
            return {
                ...state,
                currentCustomer: action.currentCustomer,
            };
        
        // FUSE CUSTOMERS
        case actionTypes.BULK_FUSE_CUSTOMERS_REQUEST:
        case actionTypes.FUSE_CUSTOMERS_REQUEST:
            return {
                ...state,
                fuseCustomersLoading: true,
            };
        case actionTypes.BULK_FUSE_CUSTOMERS_SUCCESS:
        case actionTypes.FUSE_CUSTOMERS_SUCCESS:
            return {
                ...state,
                fuseCustomersLoading: false,
                customers: deleteItemByListOfIdsInListOfItems(state.customers, action.fused),
                fuseCustomersError: null,
            };
        case actionTypes.BULK_FUSE_CUSTOMERS_ERROR:
        case actionTypes.FUSE_CUSTOMERS_ERROR:
            return {
                ...state,
                fuseCustomersError: action.error,
                fuseCustomersLoading: false,
            };

        default:
            return state;
    }
};

export default customersReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/customers.js